import { render } from "./ProjectForm.vue?vue&type=template&id=0173988f&scoped=true"
import script from "./ProjectForm.vue?vue&type=script&lang=js"
export * from "./ProjectForm.vue?vue&type=script&lang=js"

import "./ProjectForm.vue?vue&type=style&index=0&id=0173988f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0173988f"

export default script